import React from 'react'
import {
  StepContent,
  WizardStepContext,
  WizardStepContextValueType
} from '../agent-wizard-steps'
import { formatStyles } from '../../../../react-intl-helpers'
import { CodeBlockFullHeight, ContentDownloadCode } from './common'
import { CodeBlock } from '@contrast-security-inc/design-system-surfaces'
import { clusterAgentConnectionCode } from './common-container'
import { useSplitClient } from 'contrastBase/state'
import { AgentDropdown, useOrgUuid } from '../agent-config'
import { useOrganizationAgents } from '../../../../keys-settings/api/use-agent-keys'
import { KubernetesNoAgentsWarning } from './kubernetes-no-agents-warning'
import { Form } from '@contrast-security-inc/design-system-forms'
import { useFormContext } from 'react-hook-form'
import { debounce } from 'lodash'
import { TYPING_DEBOUNCE_MS } from '../common/constants'

export const hasNoAgentUsers = (multipleAgentUsersEnabled, isLoading, agents) =>
  multipleAgentUsersEnabled && !isLoading && agents.length === 0

export const StepsKubernetesConfigureOperator = () => {
  const { isSplitTreatmentOn } = useSplitClient()
  const isMultipleUsersEnabled = isSplitTreatmentOn(
    'PROD-3155_multiple_agent_users'
  )

  const orgUuid = useOrgUuid().orgUuid
  const { isLoading, data } = useOrganizationAgents({
    orgUuid,
    filterText: ''
  })

  return hasNoAgentUsers(isMultipleUsersEnabled, isLoading, data?.agents) ? (
    <KubernetesNoAgentsWarning stepContentMsg="detail_downloadAndSetupTheValuesFileNoAgents" />
  ) : (
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    <Form onSubmitSuccess={() => {}}>
      <StepsKubernetesConfigureOperatorWithAgents
        isMultipleUsersEnabled={isMultipleUsersEnabled}
      />
    </Form>
  )
}

const StepsKubernetesConfigureOperatorWithAgents = ({
  isMultipleUsersEnabled
}: {
  isMultipleUsersEnabled: boolean
}) => {
  const ctx: WizardStepContextValueType = React.useContext(WizardStepContext)

  const { watch } = useFormContext()

  React.useEffect(() => {
    const formSubscribe = watch(
      debounce((formData) => {
        ctx.updateAgentUid(formData?.agent?.uid)
      }, TYPING_DEBOUNCE_MS)
    )

    return () => formSubscribe.unsubscribe()
  }, [watch, ctx])

  return (
    <>
      <StepContent
        step={{
          Content: {
            message: 'detail_configureOperatorA',
            values: {
              ...formatStyles.doclink({ path: 'find-the-agent-keys.html' })
            }
          }
        }}
      />

      {isMultipleUsersEnabled && (
        <>
          {' '}
          <AgentDropdown /> <br />{' '}
        </>
      )}

      <CodeBlockFullHeight
        codeTemplate={`apiVersion: v1
  kind: Secret
  metadata:
    name: default-agent-connection-secret
    namespace: contrast-agent-operator
    type: Opaque
  stringData:
    apiKey: {api_key}
    serviceKey: {service_key}
    userName: {user_uid}`}
      />
      <br></br>
      <br></br>
      <CodeBlock
        style={{ width: '100%' }}
        message={'kubectl apply -f secrets.yaml'}
      />
      <ContentDownloadCode
        message="detail_configureOperatorB"
        codeTemplate={clusterAgentConnectionCode}
      />
    </>
  )
}
